export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "container_planning_alert": {
            "real_num_package_groups": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_package_groups")), " pallets registrados"])},
            "real_packages_per_pg": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_packages_per_pg")), " empaques por pallet registrados"])},
            "real_num_total_packages": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_total_packages")), " empaques registrados"])}
          }
        }
      },
      "en": {
        "model": {
          "container_planning_alert": {
            "real_num_package_groups": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_package_groups")), " pallets registered"])},
            "real_packages_per_pg": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_packages_per_pg")), " packages per pallet registered"])},
            "real_num_total_packages": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_total_packages")), " packages registered"])}
          }
        }
      }
    }
  })
}